import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../services/localStorage.service';
import {
  HQ_LOAN_BANNER,
  CLOSE_TRANSPARENT
} from 'src/defaultImages.js';

@Component({
  selector: 'app-hq-banner',
  templateUrl: './hq-banner.component.html',
  styleUrls: ['./hq-banner.component.css']
})
export class HqBannerComponent implements OnInit {
  images = {
    HQ_LOAN_BANNER,
    CLOSE_TRANSPARENT
  };

  backgroundImage: string = '';
  isAdminEnable: boolean = false;

  constructor(private _localStorage: LocalStorageService) {}

  ngOnInit(): void {
    this.backgroundImage = `url(${this.images?.HQ_LOAN_BANNER})`;
    const userType = this._localStorage.get('ee_user_type');
    this.isAdminEnable = userType === 'rest_hq_admin';
  }

  closeBanner(): void {
    this.isAdminEnable = false;
  }
}
